import { FC } from 'react'
import Link from 'components/ui/Link'
import { Logo } from '@components/ui'
import { UserNav } from '@components/common'
import { sendEvent } from '@lib/tracking'
import NavbarRoot from './NavbarRoot'

interface Link {
  href: string
  label: string
}

const Navbar: FC = () => {
  return (
    <NavbarRoot>
      <div className="flex justify-between items-center h-20">
        <Link
          href="/"
          aria-label="Logo"
          onClick={() => {
            sendEvent({
              event: 'Click_Header',
              data: {
                click_url: '/',
                click_text: 'logo',
                page_path: window.location.pathname,
                button_id: 'header_home',
              },
            })
          }}
        >
          <Logo />
        </Link>

        <UserNav />
      </div>
    </NavbarRoot>
  )
}

export default Navbar
